export default {
  galleries: [],
  selectedGallery: null,
  error: false,
  errorMessage: '',
  selectedDay: null
}